import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colorPalette, textStyles } from '../../styles/styleGuide';
import { fromBreakpoint } from '../../styles/breakpoints';
import ECWSpaceBlock from './ECWSpaceBlock';
var InterestsBlock = /*#__PURE__*/function (_Component) {
  function InterestsBlock() {
    var _this;
    _classCallCheck(this, InterestsBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InterestsBlock, [].concat(args));
    _defineProperty(_this, "state", {
      openBlock: -1
    });
    _defineProperty(_this, "handleToggle", function (id) {
      _this.setState({
        openBlock: _this.state.openBlock !== id ? id : -1
      });
    });
    return _this;
  }
  _inherits(InterestsBlock, _Component);
  return _createClass(InterestsBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        layout = _this$props.layout,
        renderWidth = _this$props.renderWidth;
      var openBlock = this.state.openBlock;
      var spaces = layout.length > 0 ? layout[0].spaces : null;
      return spaces ? __jsx(Container, {
        "data-e2e-block-ecwinterests": true,
        "data-id": "dashboard_ECWInterestsBlock_Container"
      }, __jsx(Title, {
        "data-id": "dashboard_ECWInterestsBlock_Title"
      }, "Mijn interesses"), __jsx(SubTitle, {
        "data-id": "dashboard_ECWInterestsBlock_SubTitle"
      }, "Kies \xE9\xE9n van de categorie\xEBn en bekijk per onderwerp welke voorkeuren je in het Homestudios experience center hebt aangegeven."), __jsx(Spaces, {
        "data-id": "dashboard_ECWInterestsBlock_Spaces"
      }, (spaces || []).map(function (space, index) {
        return __jsx(ECWSpaceBlock, {
          key: renderWidth > 689 ? index : index + 20,
          index: index,
          space: space,
          renderWidth: renderWidth,
          isOpen: openBlock === space.id,
          onToggle: _this2.handleToggle,
          "data-id": "dashboard_ECWInterestsBlock_ECWSpaceBlock"
        });
      }))) : null;
    }
  }]);
}(Component);
export default InterestsBlock;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: white;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 10rem 20rem 10rem;\n\n  ", ";\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 40rem 10rem 30rem 10rem;\n  "]))), fromBreakpoint.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 60rem 10rem 80rem 10rem;\n  "]))));
var Title = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  ", ";\n\n  ", ";\n"])), textStyles.sectionTitle, colorPalette.headerGrey, fromBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-left: 40rem;\n    max-width: 450rem;\n  "]))), fromBreakpoint.lg(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-left: 80rem;\n    max-width: 760rem;\n  "]))));
var SubTitle = styled.h4(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  font-style: italic;\n  margin-top: 0;\n  ", ";\n\n  ", ";\n"])), textStyles.subTitle, colorPalette.headerGrey, fromBreakpoint.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-left: 40rem;\n    max-width: 450rem;\n  "]))), fromBreakpoint.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-left: 80rem;\n    max-width: 760rem;\n  "]))));
var Spaces = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 600rem;\n  align-self: center;\n  align-items: center;\n  ", ";\n"])), fromBreakpoint.md(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    flex-flow: wrap;\n    align-items: flex-start;\n  "]))));